import React from 'react';

function Privacy() {
  return (
    <div className="privacy-page" style={{ maxWidth: 700, margin: '2rem auto', padding: '2rem', background: '#fff', borderRadius: '12px', boxShadow: '0 2px 16px rgba(44,62,80,0.08)' }}>
      <h1 style={{ color: '#DA291C', marginBottom: '1.5rem' }}>Privacy Policy</h1>
      <p>Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our LMS platform.</p>
      <h2>Information We Collect</h2>
      <ul>
        <li>Account information (name, email, password)</li>
        <li>Workshop/session participation data</li>
        <li>Usage and analytics data</li>
      </ul>
      <h2>How We Use Information</h2>
      <ul>
        <li>To provide and improve our services</li>
        <li>To communicate with you about workshops, sessions, and updates</li>
        <li>To ensure account security and platform integrity</li>
      </ul>
      <h2>Data Protection</h2>
      <p>We use industry-standard security measures to protect your data. Passwords are stored securely and sensitive information is encrypted.</p>
      <h2>Your Rights</h2>
      <ul>
        <li>You can access, update, or delete your account information at any time.</li>
        <li>Contact us for any privacy-related concerns or requests.</li>
      </ul>
      <h2>Contact</h2>
      <p>If you have questions about this Privacy Policy, please contact us at <a href="mailto:support@leadwithtech.in">support@leadwithtech.in</a>.</p>
    </div>
  );
}

export default Privacy;
